module.exports = __webpack_public_path__ + "img/p04.1ec87aaf.png";